import axios from 'axios';
import env from "@/enviroment";
import lStorage from "@/store/localStorage";
import {rest} from "@/utils/utils";

const getHeaders = () => ({
    'Authorization': 'Bearer ' + lStorage.get('auth-token'),
})

const get = (url) => axios.get(env.URL + url, {
    headers: getHeaders(),
})
const post = (url, data) => axios.post(env.URL + url, data, {
    headers: getHeaders(),
})

/**
 *
 * signin(username) - должен сохранять username если его еще нет в базе, и возвращать в поле data пару - username и password. Пароль должен создаваться случайным образом (цифры, буквы, 10 символов)
 * getCredentials - должен возвращать из бэкенда в поле data сохраненные логин и пароль {username, password}
 *
 *  В случае успеха
 *  {
 * "status":"ok",
 * "data": ...,
 * }
 *
 *  В случае не-успеха
 *  {
 *  "status": "error",
 *  "details": "...",
 * }
 *
 * Примеры ответов можно посмотреть ниже
 */
const getCredentials = () =>
    new Promise((resolve, reject) => {
        rest.call("zdj_credentials",{}).then((response)=>{
            if(response.status && response.status == "ok" && response.data){
                return resolve(response);
            }else{
                if(response.code && response.code == 1){
                    return resolve(response);
                }
                reject(response);
            }
        }).catch((error)=>{
            reject(error);
        });
    })

const signup = (username) =>
    new Promise((resolve, reject) => {
        rest.call("zdj_signup",{
            username:username
        }).then((response)=>{
            if(response.status && response.status == "ok" && response.data){
                return resolve(response);
            }else{
                reject(response);
            }
        }).catch((error)=>{
            reject(error);
        });
    });

export default {
    getCredentials,
    signup,

}
